import React from 'react';
import styles from './SwitchStatistic.module.scss';
import CompaniesDropdown from '../CompaniesDropdown/CompaniesDropdown';
import { SwitchButton } from './components/SwitchButton/SwitchButton';
import ToggleAutoUpdate from '../ToggleAutoUpdate/ToggleAutoUpdate';
import SelectUpdatePeriod from '../SelectUpdatePeriod/SelectUpdatePeriod';
import { ToggleOnlyThisPeriod } from '../ToggleOnlyThisPeriod/ToggleOnlyThisPeriod';
import cn from 'classnames';
import { ToggleShowInLifeCircle } from '../ToggleShowInLifeCircle/ToggleShowInLifeCircle';

export const SwitchStatistic = ({
  autoUpdate,
  handleAutoUpdateChange,
  autoUpdatePeriod,
  handleAutoUpdatePeriodClick,
  onlyThisPeriod,
  handleOnlyThisPeriod,
  showInLifeCirle,
  handleShowInLifeCirle,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.filtersContainer}>
        <CompaniesDropdown />
        <div className={styles.flexContainer}>
          {typeof handleAutoUpdateChange === 'function' &&
            typeof handleAutoUpdatePeriodClick === 'function' && (
              <div
                className={cn(
                  styles.autoUpdateBlock,
                  styles.autoUpdateBlock_right
                )}
              >
                <ToggleAutoUpdate
                  enabled={autoUpdate}
                  onChange={handleAutoUpdateChange}
                />
                {autoUpdate && (
                  <SelectUpdatePeriod
                    period={autoUpdatePeriod}
                    onPeriodClick={handleAutoUpdatePeriodClick}
                  />
                )}
              </div>
            )}
          {typeof handleShowInLifeCirle === 'function' &&
            typeof showInLifeCirle === 'boolean' && (
              <div
                className={cn(
                  styles.autoUpdateBlock,
                  styles.autoUpdateBlock_right
                )}
              >
                <ToggleShowInLifeCircle
                  enabled={showInLifeCirle}
                  onChange={handleShowInLifeCirle}
                />
              </div>
            )}

          {typeof handleOnlyThisPeriod === 'function' &&
            typeof onlyThisPeriod === 'boolean' && (
              <div className={styles.filterButtonBlock}>
                <ToggleOnlyThisPeriod
                  enabled={onlyThisPeriod}
                  onChange={handleOnlyThisPeriod}
                />
              </div>
            )}
        </div>
      </div>
      <SwitchButton />
    </div>
  );
};
